/**
 * US IANA options for sales_organizations.timezone.
 * Phoenix is a choice. Never a missing-zone fallback.
 */

export const US_IANA_TIMEZONES = [
  { value: 'America/New_York', label: 'Eastern (America/New_York)' },
  { value: 'America/Detroit', label: 'Michigan (America/Detroit)' },
  { value: 'America/Indiana/Indianapolis', label: 'Indiana (America/Indiana/Indianapolis)' },
  { value: 'America/Kentucky/Louisville', label: 'Kentucky (America/Kentucky/Louisville)' },
  { value: 'America/Chicago', label: 'Central (America/Chicago)' },
  { value: 'America/Denver', label: 'Mountain (America/Denver)' },
  { value: 'America/Boise', label: 'Idaho (America/Boise)' },
  { value: 'America/Phoenix', label: 'Arizona (America/Phoenix)' },
  { value: 'America/Los_Angeles', label: 'Pacific (America/Los_Angeles)' },
  { value: 'America/Anchorage', label: 'Alaska (America/Anchorage)' },
  { value: 'Pacific/Honolulu', label: 'Hawaii (Pacific/Honolulu)' }
];
